import { useLanguage, Language } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

export function useTranslation() {
  const { language } = useLanguage();

  function t<K extends keyof typeof translations>(
    section: K
  ): (typeof translations)[K]["it"] | (typeof translations)[K]["en"] {
    return translations[section][language];
  }

  return { t, language };
}
